import { useMemo } from 'react';
import useIsOperator from '../operator/useIsOperator';
import { useUserState } from './UserState';

export type OrganizationClaim = {
  id: string;
  role: 'org-admin';
};

/**
 * Hook to get user's organizations from auth claims
 */
export function useUserOrganizations(): OrganizationClaim[] {
  const { authClaims } = useUserState();

  return useMemo(() => {
    if (!authClaims || !authClaims.organizations) {
      return [];
    }
    return authClaims.organizations as OrganizationClaim[];
  }, [authClaims]);
}

/**
 * Hook to check if user is an admin of a specific organization
 */
export function useIsOrgAdmin(organizationId?: string): boolean {
  const organizations = useUserOrganizations();
  const isOperator = useIsOperator();

  return (
    isOperator ||
    (Boolean(organizationId) &&
      organizations.some((org) => org.id === organizationId && org.role === 'org-admin'))
  );
}
